import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function FeaturedEpisodes() {
  const {
    t
  } = useLanguage();
  const episodes = [{
    number: '01',
    title: t('episodes.ep1.title'),
    description: t('episodes.ep1.desc'),
    image: 'https://cdn.magicpatterns.com/uploads/4mn5uPBDrLdbXU3SXiDbje/ChatGPT_Image_13_juin_2026,_20_40_56.png',
    duration: t('episodes.ep1.duration'),
    year: '2026',
    link: 'https://podcasts.apple.com/sn/podcast/the-african-founder/id1888801055?i=1000757939068'
  }];
  return <section id="episodes" className="py-24 px-6 md:px-12 bg-archival-cream relative scroll-mt-20" data-id="element-61">
      {/* Background Pattern Accent */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-pattern-geometric opacity-20 pointer-events-none" data-id="element-62" />

      <div className="max-w-7xl mx-auto" data-id="element-63">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 border-b-4 border-gold pb-8 relative" data-id="element-64">
          {/* Decorative Pattern Line */}
          <div className="absolute bottom-[-4px] left-0 w-1/3 h-1 bg-earth-terracotta z-10" data-id="element-65" />

          <div data-id="element-66">
            <span className="font-mono text-earth-terracotta text-sm tracking-widest uppercase mb-3 block font-bold" data-id="element-67">
              {t('episodes.collection')}
            </span>
            <h2 className="text-4xl md:text-6xl font-sans font-black text-charcoal-900" data-id="element-68">
              {t('episodes.selected')}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-earth-ochre" data-id="element-69">
                {t('episodes.chapters')}
              </span>
            </h2>
          </div>
          <div className="mt-6 md:mt-0 font-mono text-charcoal-500 text-sm text-right" data-id="element-70">
            <p className="font-bold text-charcoal-900" data-id="element-71">{t('episodes.new')}</p>
            <p data-id="element-72">{t('episodes.available')}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-73">
          {episodes.map((episode, index) => <a key={episode.number} href={episode.link} target="_blank" rel="noopener noreferrer" className="group relative block" data-id="element-74">
              {/* Card Background with Pattern */}
              <div className="absolute -inset-2 bg-gradient-to-r from-gold/20 to-earth-terracotta/20 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-sm" data-id="element-75" />

              <div className="relative bg-white border border-charcoal-200 p-6 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-76">
                {/* Image Container */}
                <div className="aspect-video overflow-hidden mb-6 relative border-b-4 border-gold" data-id="element-77">
                  <img src={episode.image} alt={episode.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" data-id="element-78" />
                  <div className="absolute top-4 left-4 bg-charcoal-900 text-gold font-mono text-xs px-2 py-1 uppercase tracking-widest" data-id="element-79">
                    Ep. {episode.number}
                  </div>
                  <div className="absolute bottom-0 right-0 bg-gold text-charcoal-900 font-mono text-xs px-3 py-1 font-bold" data-id="element-80">
                    {episode.duration}
                  </div>
                </div>

                {/* Content */}
                <div className="flex justify-between items-baseline mb-3" data-id="element-81">
                  <span className="font-mono text-earth-terracotta text-sm font-bold" data-id="element-82">
                    {episode.year}
                  </span>
                </div>

                <h3 className="text-2xl font-serif font-bold text-charcoal-900 mb-3 group-hover:text-earth-terracotta transition-colors" data-id="element-83">
                  {episode.title}
                </h3>

                <p className="text-charcoal-600 font-serif leading-relaxed mb-6" data-id="element-84">
                  {episode.description}
                </p>

                <div className="flex items-center text-sm font-sans font-bold text-charcoal-900 uppercase tracking-wider group-hover:text-gold transition-colors" data-id="element-85">
                  {t('episodes.listen')} <span className="ml-2" data-id="element-86">→</span>
                </div>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}